<main class="password-page" dir="rtl">
  <section class="password-card" aria-labelledby="password-title">
    <header class="password-header">
      <h1 id="password-title">تغییر رمز عبور</h1>
    </header>

    <div class="password-notice" *ngIf="ForceChangePass" role="note">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      <p>برای ادامه استفاده از سامانه، تغییر رمز عبور الزامی است.</p>
    </div>

    <form [formGroup]="ChangePassModel" (ngSubmit)="changePass()">
      <div class="password-field">
        <label for="current-password">رمز عبور فعلی</label>
        <div class="password-input">
          <input id="current-password" formControlName="strPassword" autocomplete="current-password"
            placeholder="رمز عبور فعلی خود را وارد کنید" [type]="password ? 'text' : 'password'">
          <button type="button" class="visibility-button" (click)="changeType()"
            [attr.aria-label]="password ? 'پنهان کردن رمز عبور فعلی' : 'نمایش رمز عبور فعلی'" [attr.aria-pressed]="password">
            <i class="fa" [ngClass]="password ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="password-field">
        <label for="new-password">رمز عبور جدید</label>
        <div class="password-input">
          <input id="new-password" formControlName="strPassword2" autocomplete="new-password"
            placeholder="رمز عبور جدید را وارد کنید" [type]="password2 ? 'text' : 'password'">
          <button type="button" class="visibility-button" (click)="changeType2()"
            [attr.aria-label]="password2 ? 'پنهان کردن رمز عبور جدید' : 'نمایش رمز عبور جدید'" [attr.aria-pressed]="password2">
            <i class="fa" [ngClass]="password2 ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="password-field">
        <label for="confirm-password">تکرار رمز عبور جدید</label>
        <div class="password-input">
          <input id="confirm-password" formControlName="strPasswordNew" autocomplete="new-password"
            placeholder="رمز عبور جدید را دوباره وارد کنید" [type]="password3 ? 'text' : 'password'">
          <button type="button" class="visibility-button" (click)="changeType3()"
            [attr.aria-label]="password3 ? 'پنهان کردن تکرار رمز عبور' : 'نمایش تکرار رمز عبور'" [attr.aria-pressed]="password3">
            <i class="fa" [ngClass]="password3 ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="password-actions">
        <button type="submit" class="password-submit">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
          ذخیره رمز عبور
        </button>
        <a class="password-back" *ngIf="!ForceChangePass" [routerLink]="['/']">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
          بازگشت به سامانه
        </a>
      </div>
    </form>
  </section>
</main>
